import React from "react";
import "./Loiich.css";

const tools = [
  {
    id: 1,
    icon: "/sale.svg",
    title: "Phí thấp – báo trước – không phát sinh",
    desc: "Chỉ từ 1,1% - 1,5% (Tiết kiệm gấp 3 lần so với ATM).",
  },
  {
    id: 2,
    icon: "/shiper.svg",
    title: "Hỗ trợ tận nhà 24/7, rút toàn bộ hạn mức",
    desc: "Bị giới hạn rút tối đa 50% hạn mức. Đồng thời, bị tính phí ngay từ ngày đầu, dao động 2.5% – 3%/tháng.",
    featured: true,
  },
  {
    id: 3,
    icon: "/home.svg",
    title: "Ship nhanh 15 – 30 phút nếu cần gấp",
    desc: "",
  },
  {
    id: 4,
    icon: "/money.svg",
    title: "$ đến tay ngay",
    desc: "Giao dịch được tính như chi tiêu mua sắm, giúp tăng điểm t.ín d.ụng.",
  },
];

export default function Cloneloiich() {
  return (
    <section className="ats-section">
      <div className="ats-container">
        <div className="ats-header">
          <h2 className="text-center">Đặc quyền ship tận nhà 24/24</h2>
        </div>
        <p className="text-center" style={{ color: "#ffff" }}>
          Dịch vụ chuyên nghiệp nằm ở sự tận tâm và những đặc quyền có 102. Dù
          là 12 giờ đêm hay 2 giờ sáng, chỉ cần bạn gọi, chúng tôi có mặt.
        </p>
      </div>
      <div className="mt-5">
        <h3
          style={{
            marginTop: "1rem",
            fontWeight: "bold",
            color: "#ffff",
            textAlign: "center",
          }}
          className="hero-sec-title5"
        >
          Liên hệ ngay.
        </h3>
        <div className="d-flex align-items-center justify-content-center gap-2">
          <a
            href="tel:0941279829"
            onClick={() => {
              window.dataLayer = window.dataLayer || [];

              window.dataLayer.push({
                event: "click_call",
              });
            }}
            className="btn-purple1 mt-3 fw-bold"
          >
            0941 279 829
            <span className="btn-purple-icon">📞</span>
          </a>
        </div>
      </div>
    </section>
  );
}
